<template>
  <card class="card" title="Agregar usuario"><br />
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text" label="Usuario" placeholder="Nombre de usuario"
            v-model="user.username" :class="{
              'is-invalid': submitted && $v.user.username.$error
            }">
            </fg-input>
            <div v-if="submitted && $v.user.username.$error" class="invalid-feedback">
              <span v-if="!$v.user.username.required">El usuario es requerido</span>
            </div>
            <div v-if="submitted && $v.user.username.$error" class="invalid-feedback">
              <span v-if="!$v.user.username.isUniqueUser">El nombre de usuario ya esta registrado</span>
            </div>
          </div>
          <div class="col-md-6">
            <fg-input type="password" label="Contraseña" placeholder="Contraseña" v-model="user.password"
              pattern="(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ].*"
              title="Debe tener al menos una mayúscula, una minúscula y un dígito" :class="{
                'is-invalid': submitted && $v.user.password.$error
              }">
            </fg-input>
            <div v-if="submitted && $v.user.password.$error" class="invalid-feedback">
              <span v-if="!$v.user.password.required">
                Requerido
              </span>
              <span v-if="!$v.user.password.minLength">
                <li>8 caracteres necesarios</li>
              </span>
              <span v-if="!$v.user.password.valid1">
                <li>Al menos una mayúscula</li>
              </span>
              <span v-if="!$v.user.password.valid2">
                <li>Al menos una minúscula</li>
              </span>
              <span v-if="!$v.user.password.valid3">
                <li>Al menos un número</li>
              </span>
              <span v-if="!$v.user.password.valid4">
                <li>Al menos un caractér especial</li>
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text" label="Nombre" placeholder="Nombre completo"
              v-model="user.name" :class="{
                'is-invalid': submitted && $v.user.name.$error
              }">
            </fg-input>
            <div v-if="submitted && $v.user.name.$error" class="invalid-feedback">
              <span v-if="!$v.user.name.required">El nombre es requerido</span>
            </div>
          </div>
          <div class="col-md-6">
            <fg-input type="email" label="email" id="email" name="email"
            placeholder="email" v-model="user.email" :class="{
              'is-invalid': submitted && $v.user.email.$error
            }">
            </fg-input>
            <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
              <span v-if="!$v.user.email.required">
                <li>El email es requerido</li>
              </span>
              <span v-if="!$v.user.email.email">
                <li>Escriba el nombre del dominio</li>
              </span>
            </div>
          </div>
        </div><br />

        <div class="row">
          <div class="col-md-12">
            <!-- Estación -->
            <vSelect :options="stations" placeholder="Selecciona una estación" v-model="user.station_id"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <vSelect :options="status" placeholder="Selecciona un estatus de usuario" v-model="user.enabled" :class="{
              'is-invalid': submitted && $v.user.enabled.$error
            }" />
            <div v-if="submitted && $v.user.enabled.$error" class="invalid-feedback">
              <span v-if="!$v.user.enabled.required">El estatus es requerido</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <vSelect 
              :options="roles"
              placeholder="Selecciona un rol" 
              v-model="user.rol" 
              :class="{
                'is-invalid': submitted && $v.user.rol.$error
              }"
            />
            <div v-if="submitted && $v.user.rol.$error" class="invalid-feedback">
              <span v-if="!$v.user.rol.required">El rol es requerido</span>
            </div>
          </div>
        </div>

        <div><br />
          <p-button type="info" @click.native.prevent="handleSubmit" style="margin-right: 10px;">
            Enviar
          </p-button>
          <p-button type="danger" @click.native.prevent="handleCancel">
            Cancelar
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import usersService from '../../services/usersService';
import "vue-select/dist/vue-select.css";
import state from "../../store/state"
import vSelect from "vue-select";
import store from "../../store";
import swal from 'sweetalert';
export default {
  components: {
    vSelect
  },
  data() {
    return {
      stations: [],
      roles: [
        { label: 'Administrador', value: 'ADMIN' },
        { label: 'Estación', value: 'STATION' },
        { label: 'Soporte', value: 'SUPPORT' }
      ],
      status: ["Activo", "Cuenta Bloqueada"],
      user: {
        station_id: "",
        username: "",
        account_locked: 0,
        name: "",
        password: "",
        enabled: "Activo",
        email: "",
        rol: ''
      },
      submitted: false
    };
  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  mounted() {
    this.stations = []
    if(
      localStorage.getItem('stationsJSON') &&
      JSON.parse(localStorage.getItem('stationsJSON')).length > 0
    ) {
        this.stations = localStorage.getItem('stationsJSON') 
          ? JSON.parse(localStorage.getItem('stationsJSON')) : []
    } else {
      setTimeout(() => {
        this.stations = state.stations.select
      }, 2000)
    }
  },
  validations: {
    user: {
      username: {
        required
      },
      name: { required },
      password: {
        required,
        minLength: minLength(8),
        valid1: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          return containsUppercase;
        },
        valid2: function (value) {
          const containsLowercase = /[a-z]/.test(value);
          return containsLowercase;
        },
        valid3: function (value) {
          const containsNumber = /[0-9]/.test(value);
          return containsNumber;
        },
        valid4: function (value) {
          const containsSpecial = /[#?!@$%^&*-_]/.test(value);
          return containsSpecial;
        },
      },
      email: {
        required,
        email
      },
      enabled: { required },
      rol: { required }
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid)
        return;

      this.createUser();
    },
    handleCancel() {
      swal({
        title: '¡Aviso!',
        text: 'Se perdera tu progreso actual',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          this.$router.push("/usuarios");
        }
      })
    },
    async createUser() {
      const resp = await usersService.checkUserName(this.user.username);
      if (resp.data && resp.data.data[0]) {
        swal({
          title: '¡Algo salio mal!',
          text: 'El nombre de usuario ya existe',
          icon: 'warning',
          timer: 3000,
          buttons: false
        })
      } else {
        const { rol, station_id, enabled } = this.user
        if(
          rol.value === 'STATION' &&
          !station_id
        ) {
          swal({
            title: '¡Algo salio mal!',
            text: 'Seleeciona una estación',
            icon: 'warning',
            timer: 3000,
            buttons: false
          })
        } else {
          const response = await usersService.create(
            {
              ...this.user,
              rol: rol.value,
              station_id: station_id ? station_id : {
                  label: '',
                  station: 0
              },
              enabled: enabled === 'Activo' ? 1 : 0
            }
          )

          if (response.data.data.length === 0) {
            swal({
              title: '¡Algo salio mal!',
              text: 'El usuario no se registro correctamente',
              icon: 'warning',
              timer: 3000,
              buttons: false
            })
          } else {
            state.users.list = [];
            store.dispatch('actionGetUsers');
            swal({
              title: 'Exitoso',
              text: 'Se creo el usuario correctamente',
              icon: 'success',
              timer: 3000,
              buttons: false
            })
            setTimeout(() => {
              this.$router.push("/usuarios");
            }, 3000)
          }
        }

      }
    }
  },
};
</script>
<style></style>
